import classNames from 'classnames';

import type { BackgroundColors, GridSeperatorSizes } from './LayoutTypes';

export const getBackgroundColorClassName = (value?: BackgroundColors) => {
    switch (value) {
        case 'cotton':
            return 'sgw-layout--bg__cotton';
        default:
            return '';
    }
};

export const getGridSeperatorSizeClassName = (value?: GridSeperatorSizes) => {
    switch (value) {
        case 'small':
            return 'sgw-layout--grid-seperator-small';
        case 'large':
            return 'sgw-layout-grid-seperator-large';
        default:
            return '';
    }
};

export type ViewTypesToHide = 'mobile' | 'desktop';

export const getHiddenTypeClassName = (viewTypesToHide: ViewTypesToHide | undefined) => {
    return classNames({
        'sgw-layout-item__not-mobile': viewTypesToHide === 'mobile',
        'sgw-layout-item__mobile-only': viewTypesToHide === 'desktop',
    });
};
